import React, { useState } from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';

const MarketValidationVideo = "https://filemanagementbrandacumendlm.s3.us-east-2.amazonaws.com/video/BAsMarketValidationResearch.mp4";
const CraftingVideo = "https://filemanagementbrandacumendlm.s3.us-east-2.amazonaws.com/video/CraftingAName.mp4";
const BrandValuationVideo = "https://filemanagementbrandacumendlm.s3.us-east-2.amazonaws.com/video/BrandValuation.mp4";


const FeaturedContentCard = () => {
    const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
    // State to track if each video is playing
    const [marketValidationPlaying, setMarketValidationPlaying] = useState(false);
    const [craftingVideoPlaying, setCraftingVideoPlaying] = useState(false);
    const [brandValuationVideoPlaying, setBrandValuationVideoPlaying] = useState(false);

    return (
        <section className="py-3">
            <div className="container">
                <div className="row g-4">
                    {/* Market Validation Card */}
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-none position-relative rounded-3 overflow-hidden mb-0">
                            <div className="position-relative">
                                <VideoPlayer
                                    videoSrc={MarketValidationVideo}
                                    posterSrc={`${awsImageBaseUrl}images/BrandVault/MarketValidationCard.jpg`} 
                                    title="Market Validation"
                                    onVideoPlayingChange={setMarketValidationPlaying} // Pass the state setter
                                />
                                {/* Gradient Overlay - conditionally hide/show */}
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100 rounded-3"
                                    style={{
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)',
                                        zIndex: 1,
                                        // Conditional display based on video playing state
                                        display: marketValidationPlaying ? 'none' : 'block',
                                    }}
                                ></div>
                                {/* Title Text - conditionally hide/show */}
                                <p
                                    className="position-absolute top-0 start-0 m-3 text-white px-3 py-2 fw-bold"
                                    style={{
                                        zIndex: 2,
                                        fontSize: '1.5rem',
                                        // Conditional display based on video playing state
                                        display: marketValidationPlaying ? 'none' : 'block',
                                    }}
                                >
                                    Market Validation
                                </p>
                            </div>
                            <div className="card-body m-0">
                                <p className="fw-bold">Larger Samples with a Persona-Based Approach Build Increased Confidence</p>
                                <p className="card-text">Larger sample sizes in market research ensure each audience segment, including manufacturers, consumers, Wall Street analysts, and retailers, are represented accurately. This builds confidence in the data, 
                                    supporting nuanced insights, and enabling a reliable synthesis of perspectives for the best branding decisions.</p>
                            </div>
                        </div>
                    </div>

                    {/* Crafting The Name Card */}
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-none position-relative rounded-3 overflow-hidden mb-0">
                            <div className="position-relative">
                                <VideoPlayer
                                    videoSrc={CraftingVideo}
                                    posterSrc={`${awsImageBaseUrl}images/BrandVault/CraftingTheNameCard.jpg`} 
                                    title="Crafting The Name"
                                    onVideoPlayingChange={setCraftingVideoPlaying}
                                />
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100 rounded-3"
                                    style={{
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)',
                                        zIndex: 1,
                                        display: craftingVideoPlaying ? 'none' : 'block',
                                    }}
                                ></div>
                                <p
                                    className="position-absolute top-0 start-0 m-3 text-white px-3 py-2 fw-bold"
                                    style={{
                                        zIndex: 2,
                                        fontSize: '1.5rem',
                                        display: craftingVideoPlaying ? 'none' : 'block',
                                    }}
                                >
                                    Crafting The Name
                                </p>
                            </div>
                            <div className="card-body m-0">
                                <p className="fw-bold">Naming Must Inspire Confidence Across Both Financial and Marketing Audiences</p>
                                <p className="card-text">The combined art and science of naming requires more than market appeal, it must resonate with investors, analysts, and shareholders. A strong name conveys the company’s 
                                    future vision, aligning marketing aspirations with a clear financial strategy, building confidence across key external audiences.</p>
                            </div>
                        </div>
                    </div>

                    {/* Brand Valuation Card */}
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-none position-relative rounded-3 overflow-hidden mb-0">
                            <div className="position-relative">
                                <VideoPlayer
                                    videoSrc={BrandValuationVideo}
                                    posterSrc={`${awsImageBaseUrl}images/BrandVault/BrandValuationCard.jpg`} 
                                    title="Brand Valuation"
                                    onVideoPlayingChange={setBrandValuationVideoPlaying}
                                />
                                <div
                                    className="position-absolute top-0 start-0 w-100 h-100 rounded-3"
                                    style={{
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)',
                                        zIndex: 1,
                                        display: brandValuationVideoPlaying ? 'none' : 'block',
                                    }}
                                ></div>
                                <p
                                    className="position-absolute top-0 start-0 m-3 text-white px-3 py-2 fw-bold"
                                    style={{
                                        zIndex: 2,
                                        fontSize: '1.5rem',
                                        display: brandValuationVideoPlaying ? 'none' : 'block',
                                    }}
                                >
                                    Brand Valuation
                                </p>
                            </div>
                            <div className="card-body">
                                <p className="fw-bold">Brand Valuation Unlocks Growth Potential, Enables Market Expansion, and Exponentially Increases ROI</p>
                                <p className="card-text">Brand Valuation reveals growth opportunities and boosts ROI. Hear how it helped rebrand three distinct and emerging wound-care companies into a PE investment that resulted in Acelity, and led to the sale of the company for a significant multiple.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeaturedContentCard;